import { POST_LIST, POST_DETAIL, LOADING_POST_DETAIL } from './types';

export { fetchPostDetail } from './thunk/fetch-post-detail';

export const getPostList = (payload) => {
    return {
        type: POST_LIST,
        payload
    };
};

export const getPostDetail = (payload) => {
    return {
        type: POST_DETAIL,
        payload
    };
};

export const setIsLoadingFunc = (payload) => {
    return {
        type: LOADING_POST_DETAIL,
        payload
    };
};
